import { Component, Input, OnInit } from '@angular/core';

/**
 * Buttons are used across all websites and application to direct user to a specific page, form, or any other target.
 * Therefore icons are highlighted in the Dentsply Sirona orange color palette to ensure that they catch the user's attention.
 * Each button uses a specific icon to indicate its functionality.
 *
 * Buttons are generally placed at the end of a specific section or component to indicate the next step
 * within the userflow on the website or within the application.
 *
 * @example
 * <cfe-button [buttonStyle]="'btn-primary'" [iconName]="'back-arrow'"></cfe-button>
 *
 */
@Component({
	selector: 'cfe-button',
	templateUrl: './buttons.component.html',
	styleUrls: ['./buttons.component.scss']
})
export class ButtonsComponent implements OnInit {
	@Input() label: string;
	@Input() iconName: string;
	@Input() buttonStyle: string;

	ngOnInit() {}
}
